module.exports = __webpack_public_path__ + "static/media/GoodbyeFrenchFry_Bookcover.98fecd80.jpg";